// eslint-disable-next-line no-restricted-syntax
import { ReactElement } from 'react';
import { useDialog } from '~/hooks';
import { DialogSection } from '../dialog-section.component';
import { StyledModal as Dialog } from '../dialog.style';

export const ResetWarningDialog = ({
  target,
  handleReset,
}: {
  target: ReactElement;
  handleReset: () => void;
}) => {
  const { isOpen, close, TargetComponent } = useDialog(target);

  return (
    <>
      {TargetComponent}
      <Dialog
        isOpen={isOpen}
        onDismiss={close}
        aria-label="reset-warning"
        data-testid="reset-warning-dialog"
      >
        <Dialog.HeaderCentered title="Are you sure?" onClose={close} />
        <DialogSection>
          Marking this as complete will restart the signup workflow and remove all information
          collected from the user so far. You can’t undo this action.
        </DialogSection>
        <Dialog.FooterStacked
          primaryText="Yes, mark as completed"
          onCancel={close}
          onSubmit={handleReset}
        />
      </Dialog>
    </>
  );
};
